/* eslint-disable camelcase */
import React, { useState } from 'react'
import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from '../../../components/Popover'

import MemoDeleteSweepOutlined from '../Icons/DeleteSweepOutlined'
import MemoSettingsOutlined from '../Icons/SettingsOutlined'
import MemoDoneAll from '../Icons/DoneAll'
import { useBreakpoints } from '../../../hooks/useBreakpoints'

import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'

import MemoMoreHoriz from '../Icons/MoreHoriz'
import { useTheme } from '../../../index'
import { useNotificationsHomeContext } from '../../context'

export const HeaderActions = () => {
  const [hoveredItem, setHoveredItem] = useState(null)

  const { StyledMenuItem, threeDotsButtonStyle } = useInAppNotificationStyles()

  const {
    data: { list, unreadList, preferenceMode, tabPanelValue },
    handlers: { handleClickDelete, handleMarkAllAsRead, handleOpenConfig }
  } = useNotificationsHomeContext()

  const theme = useTheme()

  const disableDeleteButton =
    tabPanelValue === 'all' ? list?.length === 0 : unreadList?.length === 0

  const handleDelete = (e) => {
    if (disableDeleteButton) {
      return
    } else {
      handleClickDelete(e)
    }
  }

  return (
    <div onClick={(e) => e.stopPropagation()} role='menu'>
      <Popover>
        <PopoverTrigger asChild>
          <button
            style={{
              ...threeDotsButtonStyle
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            <MemoMoreHoriz
              sx={{
                fontSize: '1.25rem',
                color: theme.palette.text.secondary,
                transform: 'rotate(90deg)'
              }}
            />
          </button>
        </PopoverTrigger>

        <PopoverContent
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: theme.palette?.background?.paper || '#fff',
            borderRadius: '8px',
            padding: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 10000,
            minWidth: '150px'
          }}
          align='end'
          sideOffset={5}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {list?.length > 0 && unreadList?.length > 0 && (
              <StyledMenuItem
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  handleMarkAllAsRead(e)
                }}
                hoveredItem={hoveredItem}
                type='markAllAsRead'
                onMouseEnter={() => setHoveredItem('markAllAsRead')}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <MemoDoneAll color={theme.palette.text.secondary} />
                <span
                  style={{
                    color: theme.palette.text.primary
                  }}
                >
                  Mark all as read
                </span>
              </StyledMenuItem>
            )}
            {preferenceMode != 'none' && (
              <StyledMenuItem
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  handleOpenConfig()
                }}
                hoveredItem={hoveredItem}
                type='preferences'
                onMouseEnter={() => setHoveredItem('preferences')}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <MemoSettingsOutlined fontSize='small' />
                <span
                  style={{
                    color: theme.palette.text.primary
                  }}
                >
                  Notification Preferences
                </span>
              </StyledMenuItem>
            )}
            {list?.length > 0 && (
              <StyledMenuItem
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  handleDelete(e)
                }}
                hoveredItem={hoveredItem}
                type='delete'
                onMouseEnter={() => setHoveredItem('delete')}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <MemoDeleteSweepOutlined fontSize='small' />
                <span>Delete All</span>
              </StyledMenuItem>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}
